var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('v-form', {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.onSave.apply(null, arguments);
      }
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._l(_vm.formData.widgets, function (widget, index) {
    return [widget.type !== 'anchor' ? _c('widget-component', {
      key: widget.id || widget.name || index,
      attrs: {
        "widgetMetadata": widget
      }
    }) : [_vm._t(widget.id)]];
  })], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }